export default "__VITE_ASSET__41ae4478__"